<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top:100px;"
  >
    <!-- <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
    </div> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-center text-muted">
                <h1><b>Verify Your Information</b></h1>
                <p style="color:black; text-align:left;">
                  Please verify the information below to make sure you are entering a correct meeting room. You may provide your name in the box for ease of communication in the meeting.
                </p>
                <table style="margin-bottom:20px; color:black;">
                  <thead>
                    <td width="200px"></td>
                    <td width="600px"></td>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Meeting:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ case_id }} {{ case_description }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Login ID:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ username }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        System assigned:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        {{ name }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right; vertical-align: middle;">
                        Your name:
                      </td>
                      <td style="text-align: left; vertical-align: middle;">
                        <base-input
                          style="margin-bottom:0rem"
                          placeholder="Your Name"
                          v-model="input_name"
                        ></base-input>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="col-md-6"></div>

                <base-button type="primary" @click="ok()">OK</base-button>
                <base-button type="secondary" @click="logout()"
                  >QUIT</base-button
                >
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "InputInfo",
  data() {
    return {
      username: this.$route.params.username,
      case_id: this.$route.params.case_id,
      case_description: this.$route.params.case_description,
      name: this.$route.params.name,
      input_name: null,
    };
  },
  created() {
    window.addEventListener("beforeunload", this.close_browser);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.close_browser);
  },
  methods: {
    close_browser(e) {
      var confirmationMessage = "\o/";

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Webkit, Safari, Chrome
    },
    ok() {
      this.$router.push({
        name: "WaitingRoom",
        params: {
          username: this.username,
          case_id: this.case_id,
          case_description: this.case_description,
          name: this.name,
          input_name: this.input_name,
        },
      });
    },

    logout() {
      axios
        .get(process.env.VUE_APP_WEB_HOST + "/auth/logout", {})
        .then(() => {
          console.log("logout");
          this.$router.push({
            name: "Home",
            params: {},
          });
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
  },
  components: {},
  mounted() {
    // eslint-disable-next-line
    console.log("mounted");
  },
};
</script>

<style scoped>
section {
  overflow-y: auto;
}
table {
  border-collapse: separate;
  border-spacing: 10px 5px;
}
</style>
